import axios from 'axios'
import FormErrors from './ErrorCollection.js'
import _ from 'underscore'
import flatten from 'flat'

export default class Form {
    constructor (data) {
        this.originalData = data
        this.errors = new FormErrors()
        this.busy = false
        this.successful = false
        this.onUploadProgress = () => {}

        _.extend(this, data)
    }

    get (uri) {
        return this.submit('get', uri)
    }

    post (uri) {
        return this.submit('post', uri)
    }

    put (uri) {
        return this.submit('put', uri)
    }

    delete (uri) {
        return this.submit('delete', uri)
    }

    /**
     * Send the form to the back-end server.
     *
     * This function will clear old errors, update "busy" status, etc.
     */
    submit (method, uri) {
        let data = this.data()

        return new Promise((resolve, reject) => {
            if (this.busy) {
                return
            }

            this.startProcessing()

            axios[method](uri, data, { onUploadProgress: this.onUploadProgress })
                .then(response => {
                    this.finishProcessing()

                    resolve(response.data)
                })
                .catch(error => {
                    this.finishWithErrors(error.response.data)

                    reject(error.response.data)
                })
        })
    }

    /**
     * Start processing the form.
     */
    startProcessing () {
        this.busy = true
        this.successful = false
    };

    /**
     * Finish processing the form.
     */
    finishProcessing () {
        this.busy = false
        this.successful = true
        this.errors.forget()
    };

    finishWithErrors (errors) {
        this.errors.set(errors.errors)
        this.busy = false
        this.successful = false
    };

    hasErrors () {
        return this.errors.hasErrors()
    };

    set (field, value) {
        this[field] = value
        this.originalData[field] = value
    }

    getOnlyPresentFields (data) {
        let clean = {}

        for (var field in data) {
            if (typeof data[field] === 'function') {
                continue
            }

            if (typeof data[field] === 'object' && !_.isEmpty(data[field])) {
                clean[field] = this.getOnlyPresentFields(data[field])
            } else if (data[field] !== null) {
                clean[field] = data[field]
            }
        }

        return clean
    }

    dataFromOriginalFields () {
        let data = {}

        for (let field in this.originalData) {
            data[field] = this[field]
        }

        return this.getOnlyPresentFields(data)
    }

    flattedData () {
        return flatten(this.dataFromOriginalFields())
    }

    hasFiles () {
        let data = this.flattedData()

        for (let field in data) {
            if (data[field] instanceof File) {
                return true
            }
        }

        return false
    }

    data () {
        return this.hasFiles() ? this.toFormData() : this.dataFromOriginalFields()
    }

    toFormData () {
        let formData = new FormData()
        let data = this.flattedData()

        for (let fieldKey in data) {
            let key = fieldKey.split('.').reduce((carry, key, index) => {
                return index == 0 ? key : `${carry}[${key}]`
            }, '')

            formData.append(key, data[fieldKey])
        }

        return formData
    }
}
